import * as React from "react"
import {observer} from "mobx-react"
import {i18n} from "@cling/lib.web.i18n"
import {import_board_state, ui_state} from "../state/index"
import {Button} from "@cling/lib.web.mdc"
import {JobStatus} from "@cling/lib.shared.model"
import {assert_never, not_null} from "@cling/lib.shared.utils"
import {goto_board} from "../utils"
import {report_error} from "@cling/lib.shared.debug"
import {running_on_mobile_device} from "@cling/lib.web.utils"
import {classNames} from "@cling/lib.web.utils"
import {runInAction} from "mobx"

export const ImportBoardToast = observer(() => {
    const open_imported_board = React.useCallback(() => {
        import_board_state.close_toast()
        goto_board({board_uid: not_null(import_board_state.board_uid)}).catch(report_error)
    }, [])
    const ref = React.useCallback((elm?: ReactRef<HTMLDivElement>) => {
        runInAction(() => {
            ui_state.toast_shown = !!elm
        })
    }, [])
    const {job_status} = import_board_state
    if (!job_status) {
        return null
    }
    let text: string
    let failure = false
    let success = false
    if (job_status === JobStatus.job_pending || job_status === JobStatus.job_running) {
        text = i18n.importing_board
    } else if (job_status === JobStatus.job_failed) {
        failure = true
        text = i18n.import_failed
    } else if (job_status === JobStatus.job_succeeded) {
        success = true
        text = i18n.board_successfully_imported
    } else {
        throw assert_never(job_status)
    }
    return (
        <div
            className={classNames("toast", {
                "toast--with-bottom-app-bar": running_on_mobile_device() && ui_state.app_bar_shown,
            })}
            ref={ref}
        >
            <span className="toast__text">{text}</span>
            <div className="toast__action">
                {(failure || success) && (
                    <Button onClick={import_board_state.close_toast}>{i18n.close}</Button>
                )}
                {failure && <Button onClick={import_board_state.retry_import}>{i18n.retry}</Button>}
                {success && (
                    <Button
                        onClick={open_imported_board}
                        data-test-id="ImportBoardToast_open_imported_board"
                    >
                        {i18n.open}
                    </Button>
                )}
            </div>
        </div>
    )
})
